'use client';
import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import { Route } from 'next';

interface DesignerLinkProps {
  text: string;
  href: Route;
  target?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
}

export function DesignerLink({
  text,
  href,
  target,
  onClick,
  className,
}: DesignerLinkProps) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <Link
      href={href}
      target={target}
      onClick={handleClick}
      rel='noopener noreferrer'
      className={twMerge(
        'text-designer-blue font-semibold hover:text-white transition-colors duration-300 items-center',
        className
      )}
    >
      {text}
      {/* <span className='ml-1'>&gt;&gt;</span> */}
    </Link>
  );
}
